export const refundType = {
    TO_ACTIVE: 'TO_ACTIVE',
    TO_BOTH: 'TO_BOTH',
    TO_INACTIVE: 'TO_INACTIVE',
};
